import type { ObjectIconInfo } from '../../utils/parse_object_icon_info';
import { ObjectIcon } from '../object_icon/object_icon';

import styles from './object_icon_thumbnail.module.css';

type Props = {
  objectIconInfo: ObjectIconInfo;
};

export function ObjectIconThumbnail({ objectIconInfo }: Props) {
  return (
    <div className={styles.thumbnail_root}>
      <ObjectIcon
        className={styles.thumbnail_icon}
        info={objectIconInfo}
        size={40}
      />
    </div>
  );
}
